export default "__VITE_ASSET__05458a48__"